var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('UsuarioForm',[_c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.atualizarUsuario($event)}}},[_vm._v("Atualizar Usuário")])]),_c('ErroNotificacao',{attrs:{"erros":_vm.erros}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }